import React, { ErrorInfo, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'ui';
import { withUseLogout } from '../hoc';
import { useLogout } from '../hooks';

class ErrorBoundaryClass extends React.Component<
  {
    children: ReactNode;
    homeUrl: string;
    logout: ReturnType<typeof useLogout>;
  },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.VITE_NODE_ENV === 'production') {
      this.props.logout();
    } else {
      console.log(error, info);
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return import.meta.env.VITE_NODE_ENV === 'production' ? (
      <div></div>
    ) : (
      <div className="w-screen h-screen flex justify-center items-center">
        <div className="max-w-3xl p-3 space-y-4">
          <p className="text-3xl">Something is causing app not to work for you</p>
          <p>
            Try refreshing the page, you might have an unstable internet connection or UI couldn't
            handle your operation. If the issue didn't go away and you need immediate assistance,
            please contact our support team at{' '}
            <a href="mailto:support@complione.com.au">support@complione.com.au</a>.
          </p>
          <p>
            <Link to={this.props.homeUrl} onClick={() => this.setState({ hasError: false })}>
              <Button>Home</Button>
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export const ErrorBoundary = withUseLogout(ErrorBoundaryClass);
